// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__1zfQ0","spacer":"menu_spacer__1JfoT"};